export const BACH_FLOWERS_DATA = [
  {
    id: "agrimony",
    name: "Agrimony",
    latin: "Agrimonia eupatoria",
    spanish: "Agrimonia",
    group: "Hipersensibilidad",
    negative: "Oculta sufrimientos tras una máscara de alegría. Evita la soledad y busca evasión.",
    positive: "Paz interior real. Capacidad de integrar desafíos con serenidad y autenticidad.",
    considerations: "Acompaña estados de inquietud interna, tensión mandibular y hábitos de evasión."
  },
  {
    id: "aspen",
    name: "Aspen",
    latin: "Populus tremula",
    spanish: "Álamo temblón",
    group: "Miedo",
    negative: "Aprensión sin causa conocida, presagios o miedos imprecisos ante lo desconocido.",
    positive: "Confianza y seguridad. Coraje basado en la calma interna y la protección.",
    considerations: "Ideal para el descanso nocturno inquieto y la sensación de vulnerabilidad emocional."
  },
  {
    id: "beech",
    name: "Beech",
    latin: "Fagus sylvatica",
    spanish: "Haya",
    group: "Preocupación por otros",
    negative: "Tendencia a la crítica y la intolerancia. Dificultad para comprender otros puntos de vista.",
    positive: "Tolerancia, humildad y empatía hacia las diferencias ajenas.",
    considerations: "Fomenta la relajación en zonas de tensión cervical y mejora la tolerancia digestiva."
  },
  {
    id: "centaury",
    name: "Centaury",
    latin: "Centaurium umbellatum",
    spanish: "Centaura",
    group: "Hipersensibilidad",
    negative: "Dificultad para poner límites. Voluntad débil y tendencia al sometimiento por agradar.",
    positive: "Fortaleza de la voluntad propia. Capacidad de servir con sabiduría y límites sanos.",
    considerations: "Útil en periodos de debilidad física o fatiga por exceso de entrega a los demás."
  },
  {
    id: "cerato",
    name: "Cerato",
    latin: "Ceratostigma willmottiana",
    spanish: "Ceratostigma",
    group: "Incertidumbre",
    negative: "Busca consejo constantemente por desconfianza en su propia intuición.",
    positive: "Confianza en el juicio propio. Intuición clara y seguridad en las decisiones.",
    considerations: "Acompaña procesos de dispersión mental y falta de enfoque en objetivos."
  },
  {
    id: "cherry-plum",
    name: "Cherry Plum",
    latin: "Prunus cerasifera",
    spanish: "Cerasífera",
    group: "Miedo",
    negative: "Miedo a perder el control emocional. Impulsividad o desesperación intensa.",
    positive: "Control emocional y serenidad profunda incluso en situaciones de gran presión.",
    considerations: "Acompaña estados de tensión nerviosa extrema y descontrol de impulsos físicos."
  },
  {
    id: "chestnut-bud",
    name: "Chestnut Bud",
    latin: "Aesculus hippocastanum",
    spanish: "Brote de Castaño",
    group: "Falta de interés",
    negative: "Repetición de errores por falta de observación. No aprende de la experiencia.",
    positive: "Aprendizaje rápido. Capacidad de asimilar lecciones y avanzar con sabiduría.",
    considerations: "Fomenta la atención en el presente y el aprendizaje en procesos de desarrollo."
  },
  {
    id: "chicory",
    name: "Chicory",
    latin: "Cichorium intybus",
    spanish: "Achicoria",
    group: "Preocupación por otros",
    negative: "Posevidad y manipulación afectiva. Necesidad excesiva de atención y control.",
    positive: "Amor incondicional y desinteresado. Capacidad de dar libertad a los seres queridos.",
    considerations: "Relaja tensiones asociadas a la congestión emocional y el estancamiento circulatorio."
  },
  {
    id: "clematis",
    name: "Clematis",
    latin: "Clematis vitalba",
    spanish: "Clemátide",
    group: "Falta de interés",
    negative: "Soñador, distraído, falta de interés por el presente. Tendencia a la evasión mental.",
    positive: "Creatividad manifestada en la realidad. Presencia, atención y realismo práctico.",
    considerations: "Ayuda en la somnolencia y la falta de nitidez en los sentidos por distracción."
  },
  {
    id: "crab-apple",
    name: "Crab Apple",
    latin: "Malus pumila",
    spanish: "Manzano silvestre",
    group: "Abatimiento",
    negative: "Sentimiento de impureza o autorrechazo. Obsesión por detalles físicos o limpieza.",
    positive: "Aceptación de uno mismo. Purificación mental y sentido de la proporción.",
    considerations: "Promueve el bienestar cutáneo y acompaña procesos de desintoxicación."
  },
  {
    id: "elm",
    name: "Elm",
    latin: "Ulmus procera",
    spanish: "Olmo",
    group: "Abatimiento",
    negative: "Abrumado por las responsabilidades. Sensación temporal de incapacidad ante las tareas.",
    positive: "Seguridad en las capacidades. Capacidad de delegar y reconocer los límites.",
    considerations: "Acompaña crisis de estrés por sobrecarga laboral o familiar intensa."
  },
  {
    id: "gentian",
    name: "Gentian",
    latin: "Gentiana amarella",
    spanish: "Genciana",
    group: "Incertidumbre",
    negative: "Desánimo fácil ante obstáculos. Pesimismo y duda sobre los resultados positivos.",
    positive: "Perseverancia y fe. Comprensión de que los retos son parte del progreso.",
    considerations: "Apoya en convalecencias lentas y estados de desánimo por causas conocidas."
  },
  {
    id: "gorse",
    name: "Gorse",
    latin: "Ulex europaeus",
    spanish: "Aulaga",
    group: "Incertidumbre",
    negative: "Desesperanza total. Sensación de que nada puede mejorar su situación.",
    positive: "Recuperación de la esperanza y la voluntad de seguir adelante con fe.",
    considerations: "Ideal para situaciones crónicas donde se ha perdido el impulso vital."
  },
  {
    id: "heather",
    name: "Heather",
    latin: "Calluna vulgaris",
    spanish: "Brezo",
    group: "Soledad",
    negative: "Centrado en sí mismo. Necesita público constante. Dificultad para estar solo.",
    positive: "Empatía y escucha activa. Capacidad de dar y recibir en equilibrio.",
    considerations: "Acompaña la ansiedad por soledad y la necesidad de comunicación excesiva."
  },
  {
    id: "holly",
    name: "Holly",
    latin: "Ilex aquifolium",
    spanish: "Acebo",
    group: "Hipersensibilidad",
    negative: "Odio, envidia, celos o sospecha. Sentimientos de ira interna intensa.",
    positive: "Amor universal y apertura emocional. Generosidad y paz de corazón.",
    considerations: "Fomenta la calma en reacciones explosivas y estados de calor corporal interno."
  },
  {
    id: "honeysuckle",
    name: "Honeysuckle",
    latin: "Lonicera caprifolium",
    spanish: "Madreselva",
    group: "Falta de interés",
    negative: "Nostalgia excesiva. Vivir anclado en el pasado, dificultad para aceptar cambios.",
    positive: "Vivir plenamente el presente integrando las experiencias pasadas con sabiduría.",
    considerations: "Acompaña procesos de duelo, mudanzas o cambios de etapa vital."
  },
  {
    id: "hornbeam",
    name: "Hornbeam",
    latin: "Carpinus betulus",
    spanish: "Hojaranzo",
    group: "Incertidumbre",
    negative: "Pereza mental. Cansancio ante la idea de empezar el día o la tarea.",
    positive: "Vitalidad y entusiasmo mental. Frescura para afrontar la rutina diaria.",
    considerations: "Fomenta la firmeza en tejidos y ayuda en la sensación de laxitud física."
  },
  {
    id: "impatiens",
    name: "Impatiens",
    latin: "Impatiens glandulifera",
    spanish: "Impaciencia",
    group: "Soledad",
    negative: "Prisa constante e irritabilidad por la lentitud ajena. Tensión nerviosa extrema.",
    positive: "Paciencia y ritmo armonioso. Aceptación de los tiempos de los demás.",
    considerations: "Relaja tensiones musculares agudas y estados de inquietud motora."
  },
  {
    id: "larch",
    name: "Larch",
    latin: "Larix decidua",
    spanish: "Alerce",
    group: "Abatimiento",
    negative: "Expectativa de fracaso. Sentimiento de inferioridad que impide la acción.",
    positive: "Capacidad de actuar con confianza. Reconocimiento del valor personal.",
    considerations: "Acompaña procesos de desvalorización y fomenta la seguridad al hablar en público."
  },
  {
    id: "mimulus",
    name: "Mimulus",
    latin: "Mimulus guttatus",
    spanish: "Mímulo",
    group: "Miedo",
    negative: "Miedos concretos y conocidos (dinero, soledad, accidentes). Timidez social.",
    positive: "Valentía silenciosa. Capacidad de enfrentar las pruebas cotidianas con calma.",
    considerations: "Acompaña la sensibilidad excesiva al ruido, la luz o el entorno social."
  },
  {
    id: "mustard",
    name: "Mustard",
    latin: "Sinapis arvensis",
    spanish: "Mostaza",
    group: "Falta de interés",
    negative: "Tristeza profunda y repentina que aparece y desaparece sin causa externa clara.",
    positive: "Estabilidad emocional y alegría interior independiente de las circunstancias.",
    considerations: "Aporta claridad y ligereza en estados de pesadez anímica cíclica."
  },
  {
    id: "oak",
    name: "Oak",
    latin: "Quercus robur",
    spanish: "Roble",
    group: "Abatimiento",
    negative: "Luchador que ignora su propio agotamiento. Sentido del deber rígido y excesivo.",
    positive: "Fuerza flexible. Capacidad de reconocer los límites y permitirse el descanso.",
    considerations: "Relaja contracturas crónicas en hombros y espalda por exceso de carga."
  },
  {
    id: "olive",
    name: "Olive",
    latin: "Olea europaea",
    spanish: "Olivo",
    group: "Falta de interés",
    negative: "Agotamiento total tras un periodo de gran esfuerzo, físico o mental.",
    positive: "Regeneración energética profunda. Recuperación de la paz y la vitalidad.",
    considerations: "Fundamental en periodos de fatiga extrema y recuperación energética."
  },
  {
    id: "pine",
    name: "Pine",
    latin: "Pinus sylvestris",
    spanish: "Pino",
    group: "Abatimiento",
    negative: "Culpa y autorreproche constante. Se responsabiliza de errores ajenos.",
    positive: "Perdón y aceptación propia. Responsabilidad sana sin juicio destructivo.",
    considerations: "Libera tensiones asociadas al autocastigo y la insatisfacción personal."
  },
  {
    id: "red-chestnut",
    name: "Red Chestnut",
    latin: "Aesculus carnea",
    spanish: "Castaño rojo",
    group: "Miedo",
    negative: "Preocupación excesiva y miedo por la seguridad de los seres queridos.",
    positive: "Cuidar a los demás con calma y confianza. Proyectar seguridad.",
    considerations: "Promueve la tranquilidad en vínculos de codependencia emocional."
  },
  {
    id: "rock-rose",
    name: "Rock Rose",
    latin: "Helianthemum nummularium",
    spanish: "Heliantemo",
    group: "Miedo",
    negative: "Pánico y terror paralizante. Reacción desproporcionada ante emergencias.",
    positive: "Valor heroico y presencia de ánimo en situaciones límite de peligro.",
    considerations: "Útil en estados de agitación nerviosa súbita y sobresaltos nocturnos."
  },
  {
    id: "rock-water",
    name: "Rock Water",
    latin: "Agua de roca",
    spanish: "Agua de roca",
    group: "Preocupación por otros",
    negative: "Autodisciplina rígida y perfeccionismo extremo. Martirio por ideales.",
    positive: "Flexibilidad y fluidez. Disfrutar del proceso con amabilidad hacia uno mismo.",
    considerations: "Fomenta la elasticidad física y relaja la rigidez en las articulaciones."
  },
  {
    id: "scleranthus",
    name: "Scleranthus",
    latin: "Scleranthus annuus",
    spanish: "Escleranto",
    group: "Incertidumbre",
    negative: "Indecisión entre dos opciones. Oscilaciones de humor e inestabilidad.",
    positive: "Equilibrio, resolución y centro. Decisión rápida basada en la claridad.",
    considerations: "Acompaña en sensaciones de inestabilidad física y mareos por descompensación."
  },
  {
    id: "star-of-bethlehem",
    name: "Star of Bethlehem",
    latin: "Ornithogalum umbellatum",
    spanish: "Leche de gallina",
    group: "Abatimiento",
    negative: "Bloqueo emocional o físico tras un impacto traumático reciente o antiguo.",
    positive: "Consuelo, alivio e integración del impacto traumático. Paz energética.",
    considerations: "Favorece la liberación de bloqueos y apoya la cicatrización emocional."
  },
  {
    id: "sweet-chestnut",
    name: "Sweet Chestnut",
    latin: "Castanea sativa",
    spanish: "Castaño dulce",
    group: "Abatimiento",
    negative: "Angustia extrema al límite de la resistencia. Desesperación profunda.",
    positive: "Transformación y luz tras la crisis. Renacimiento emocional.",
    considerations: "Apoya en momentos de transición existencial profunda y quiebre emocional."
  },
  {
    id: "vervain",
    name: "Vervain",
    latin: "Verbena officinalis",
    spanish: "Verbena",
    group: "Preocupación por otros",
    negative: "Entusiasmo excesivo que agota. Fanatismo e incapacidad para relajarse.",
    positive: "Moderación y capacidad de inspirar a otros con calma y tolerancia.",
    considerations: "Fomenta la relajación muscular y ayuda en el descanso ante el exceso de ideas."
  },
  {
    id: "vine",
    name: "Vine",
    latin: "Vitis vinifera",
    spanish: "Vid",
    group: "Preocupación por otros",
    negative: "Dominación, tiranía e inflexibilidad. Exigencia de obediencia absoluta.",
    positive: "Liderazgo sabio, comprensivo y motivador. Respeto por los demás.",
    considerations: "Relaja tensiones asociadas a la necesidad de control y el autoritarismo."
  },
  {
    id: "walnut",
    name: "Walnut",
    latin: "Juglans regia",
    spanish: "Nogal",
    group: "Hipersensibilidad",
    negative: "Dificultad ante los cambios o transiciones. Influenciable por el entorno.",
    positive: "Protección y adaptabilidad. Mantener el camino propio en momentos de cambio.",
    considerations: "Ideal para etapas de transición biológica: pubertad, cambios de vida o menopausia."
  },
  {
    id: "water-violet",
    name: "Water Violet",
    latin: "Hottonia palustris",
    spanish: "Violeta de agua",
    group: "Soledad",
    negative: "Orgullo y distanciamiento. Se siente superior y se aísla de los demás.",
    positive: "Humildad y cercanía compartiendo la sabiduría personal con el grupo.",
    considerations: "Acompaña la rigidez en la parte alta de la columna y el aislamiento social."
  },
  {
    id: "white-chestnut",
    name: "White Chestnut",
    latin: "Castaño de Indias",
    spanish: "Castaño blanco",
    group: "Falta de interés",
    negative: "Rumiación mental. Pensamientos circulares que impiden la paz y el descanso.",
    positive: "Claridad, paz mental y control sobre los procesos de pensamiento.",
    considerations: "Ideal para conciliar el descanso nocturno ante el ruido mental constante."
  },
  {
    id: "wild-oat",
    name: "Wild Oat",
    latin: "Bromus ramosus",
    spanish: "Avena silvestre",
    group: "Incertidumbre",
    negative: "Desorientación vocacional o falta de propósito claro en la vida.",
    positive: "Claridad de metas y definición del sentido vital y profesional.",
    considerations: "Acompaña crisis de identidad y momentos de redefinición de objetivos personales."
  },
  {
    id: "wild-rose",
    name: "Wild Rose",
    latin: "Rosa canina",
    spanish: "Rosa silvestre",
    group: "Falta de interés",
    negative: "Apatía, resignación y falta de motivación ante la vida.",
    positive: "Entusiasmo vital y participación gozosa en la experiencia diaria.",
    considerations: "Aporta energía en estados de desinterés profundo y falta de vitalidad sexual."
  },
  {
    id: "willow",
    name: "Willow",
    latin: "Salix vitellina",
    spanish: "Sauce",
    group: "Abatimiento",
    negative: "Resentimiento, amargura y victimismo. Sensación de injusticia constante.",
    positive: "Responsabilidad propia, perdón y optimismo constructivo.",
    considerations: "Fomenta la fluidez articular y mejora el confort digestivo ante el rencor."
  }
];
